import { iframeResizer } from 'iframe-resizer';

const iframe = document.querySelector('iframe');
const { search } = window.location;

iframeResizer({ checkOrigin: false }, iframe);

if (search) {
  iframe.src = `${iframe.src}${search}`;
}
